import React from 'react'
import { FormattedMessage } from 'react-intl'
import Button from '../../../components/button/Button'
import { makeStyles } from '@material-ui/core/styles'
import styles from '../../../styles'
import { ClassValue } from 'classnames/types'
import classNames from 'classnames'
import { useHistory } from 'react-router'
import links from '../../../enums/linksEnum'

const useStyle = makeStyles(
    (theme) => (
        {
            ...styles(theme),
            questionContainerStyle: {
                marginTop: 20,
                backgroundColor: theme.palette.accessibility.main,
                padding: 27
            },
            buttonStyle: {
                width: '70%',
                maxWidth: 120
            }
        }
    )
)

const Questions = () => {
    const classes = useStyle()
    const history = useHistory()

    const titleClass: ClassValue = classNames(
        classes.text0,
        classes.colorWhite
    )

    const textClass: ClassValue = classNames(
        classes.text1,
        classes.colorWhite
    )

    const goToQuestions = () => {
        history.push(links.questions)
    }

    return (
        <div className={classes.questionContainerStyle}>
            <h1 className={titleClass}>
                <FormattedMessage
                    id="news.questions.title"
                    defaultMessage="Vous avez une questions ?"
                    description="Question's title"
                />
            </h1>

            <p className={textClass}>
                <FormattedMessage
                    id="news.questions.text"
                    defaultMessage="Trouvez votre réponse rapidement"
                    description="Question's text"
                />
            </p>

            <div className={classes.buttonStyle}>
                <Button
                    background="backgroundWhite"
                    color="colorAccessibility"
                    textStyle="text8"
                    onClick={goToQuestions}
                >
                    <FormattedMessage
                        id="news.questions.button"
                        defaultMessage="Consulter"
                        description="Question's button"
                    />
                </Button>
            </div>
        </div>
    )
}

export default Questions
